import { Formik, FormikHelpers } from 'formik'
import * as React from 'react'
import { useCallback } from 'react'
import { IFilterChipListWrapperProps, IFilterSet } from '../typings'
import { FilterChipList } from './FilterChipList'

export function FilterChipListWrapper<U, T extends IFilterSet<U>>(
  props: IFilterChipListWrapperProps<T>,
) {
  const { applyCallback, filterSet, clearedFilters, entityType, width } = props

  const onSubmit = useCallback(
    (model: T, { setSubmitting }: FormikHelpers<T>) => {
      applyCallback(model)
      setSubmitting(false)
    },
    [applyCallback],
  )

  return (
    <Formik
      {...props}
      onSubmit={onSubmit}
      initialValues={filterSet}
      enableReinitialize
    >
      <FilterChipList<U, T>
        entityType={entityType}
        clearedFilters={clearedFilters}
        width={width}
      />
    </Formik>
  )
}
